import {
  Content,
  ContentHeader,

} from '@backstage/core-components';
import { Header } from '@internal/plugin-components-react';
import { useApi } from '@backstage/core-plugin-api';
import React, { useState } from 'react';
import { Table, Alert } from '@internal/plugin-components-react';
import useAsyncRetry from 'react-use/lib/useAsyncRetry';
import {
  Typography,
  Button,
  Grid,
  Paper,
  LinearProgress,
  Box,
} from '@material-ui/core';
import {
  deploymentManagementApiRef,


} from '../../api/types';
import { useParams } from 'react-router-dom';
import AutoComplete from '@internal/plugin-components-react/src/common/AutoComplete';
import useAsyncFn from 'react-use/lib/useAsyncFn';
import { CustomerEnvVarEditPage } from './CustomerEnvVarEditPage';
import { EmptyTableContent } from '@internal/plugin-components-react/src/common/Table/EmptyTableContent';

const columns = [
  {
    title: 'Service Name',
    field: 'serviceName',
    width: '25%',
    render: ({ serviceName }) => serviceName,
  },
  {
    title: 'Key',
    field: 'variableName',
    width: '25%',
    render: ({ variableName }) => variableName,
  },
  {
    title: 'Value',
    field: 'variableValue',
    width: '25%',
    render: ({ variableValue }) => variableValue,
  },
  {
    title: 'Kind',
    field: 'kind',
    width: '25%',
    render: ({ kind }) => kind,
  },
];

export const CustomerEnvVarPage = () => {
  const { environmentId: environmentIdFromParam } = useParams();
  const [page, setPage] = useState('MAIN');
  const deploymentManagementApi = useApi(deploymentManagementApiRef);
  const [environmentId, setEnvironmentId] = useState(
    Number(environmentIdFromParam) || null,
  );

  const { value: responseGetEnvironments, loading: isFetchingEnvironment } =
    useAsyncRetry(async () => {
      const response = await deploymentManagementApi.getEnvironments();
      response.data?.sort((a, b) =>
        `${a.customerName} ${a.environmentName}`.localeCompare(
          `${b.customerName} ${b.environmentName}`,
        ),
      );
      return response;
    }, []);

  const [
    {
      value: environmentVariables,
      loading: isFetchingEnvironmentVariables,
      error: errorFetchingEnvironmentVariables,
    },
    getEnvironmentVariables,
  ] = useAsyncFn(async (environmentId) => {
    return deploymentManagementApi.getEnvironmentVariables(environmentId);
  }, []);

  React.useEffect(() => {
    if (environmentId) {
      getEnvironmentVariables(String(environmentId));
      window.history.replaceState(
        {},
        '',
        `/deployment-management/env-var/${environmentId}`,
      );
    }
  }, [environmentId]);

  const currentEnvironment = responseGetEnvironments?.data.find(environment => {
    environment.environmentId === environmentId;
  });

  const renderHeader = () => (
    React.createElement(Header, { title: "Deployment Management" , breadcrumbItems: getBreadcrumbs(),} )
  );

  const getBreadcrumbs = () => {
    const breadcrumbItems = [
      { text: 'Deployment Management', href: '/deployment-management' },
      {
        text: 'Customer Env Var',
        href: '/deployment-management/env-var',
      },
    ];
    if (currentEnvironment?.customerName) {
      breadcrumbItems.push({
        text: currentEnvironment.customerName,
        href: `/deployment-management/env-var/${currentEnvironment.customerName}`,
      });
    }
    return breadcrumbItems;
  };

  if (environmentId && page === 'EDIT' && environmentVariables) {
    return (
      React.createElement(React.Fragment, null
        , renderHeader()
        , React.createElement(CustomerEnvVarEditPage, {
          environmentVariables: environmentVariables,
          onCancel: () => setPage('MAIN'),
          onSubmit: () => {
            setPage('MAIN');
            getEnvironmentVariables(String(environmentId));
          },}
        )
      )
    );
  }

  return (
    React.createElement(React.Fragment, null
      , renderHeader()
      , React.createElement(Content, null
        , React.createElement(ContentHeader, {
          titleComponent: 
            React.createElement(Typography, { variant: "h5",}, "Environment Variable List"  )
          ,}
        
          , environmentId !== null && (
            React.createElement(Button, {
              variant: "contained",
              color: "primary",
              onClick: () => setPage('EDIT'),}
            , "Edit"

            )
          )
        )
        , React.createElement(Box, { display: "flex", justifyContent: "center",}
          , React.createElement(Box, { style: { width: '330px', marginRight: '16px' },}
            , React.createElement(Grid, {
              container: true,
              spacing: 2,
              component: Paper,
              style: { padding: '1rem', boxShadow: 'none' },}
            
              , React.createElement(Grid, { item: true, xs: 12, style: { padding: '0', boxShadow: 'none' },}
                , isFetchingEnvironment && React.createElement(LinearProgress, { color: "secondary",} )
                , responseGetEnvironments && responseGetEnvironments.data && (
                  React.createElement(AutoComplete, {
                    optionLabelField: ['customerName', 'environmentName'],
                    list: responseGetEnvironments.data,
                    onChange: (environment) => {
                      setEnvironmentId(environment?.environmentId || null);
                    },
                    inputLabel: "Select Customer and Environment"   ,
                    value: responseGetEnvironments.data?.find(
                      environment =>
                        environment.environmentId === environmentId,
                    ),}
                  )
                )
              )
            )
          )
          , React.createElement(Box, { style: { width: '100%' },}
            , errorFetchingEnvironmentVariables && (
              React.createElement(Alert, {
                severity: "error",
                title: "Fetch deployment plan error"   ,
                message: "Oops! An error occurred while fetching deployment plan, please reach out to our support team for help."                ,}
              
                , React.createElement(Button, {
                  variant: "contained",
                  color: "secondary",
                  onClick: () => getEnvironmentVariables(String(environmentId)),}
                , "Retry"

                )
              )
            )
            , React.createElement(Table, {
              options: {
                paging: false,
                maxBodyHeight: 'calc(100vh - 330px)',
              },
              columns: columns,
              data: environmentVariables || [],
              emptyContent: 
                React.createElement(EmptyTableContent, null
                  , environmentId === null
                    ? 'Please select one customer environment first'
                    : environmentVariables?.length === 0
                    ? "There's no customer environment plan yet"
                    : null
                )
              ,
              isLoading: 
                isFetchingEnvironment || isFetchingEnvironmentVariables
              ,}
            )
          )
        )
      )
    )
  );
};
